module.exports = __webpack_public_path__ + "static/media/accessible-room.fb8cb18a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/accessible-room.svg
// module id = 857
// module chunks = 0